(ns app.front.view.conversations.core
  #_{:clj-kondo/ignore [:refer]} ; npm import
  (:require ["react-intersection-observer" :refer (InView)]
            [app.domain.acceptance.model :as acceptance-model]
            [app.domain.business.model :as business-model]
            [app.domain.conversation.model :as conversation-model]
            [app.domain.review.model :as review-model]
            [app.domain.util :as du]
            [app.domain.workspace.model :as workspace-model]
            [app.front.entities :as entities]
            [app.front.ui :as ui]
            [app.front.ui.drawer :as drawer]
            [app.front.ui.rich-text :as ui-rt]
            [app.front.ui.sticky :as sticky]
            [app.front.ui.transitions :as t]
            [app.front.util :refer [cs for-frag parse-int tval] :as futil]
            [app.front.view.application.permissions :as permissions]
            [app.front.view.party.common :as party-common]
            [app.front.view.workspace.hidden-description :as ws-hidden-desc]
            [app.front.view.workspace.subs :as ws-subs]
            [clojure.set :as set]
            [clojure.string :as str]
            [core.front.carbon :as cc]
            [core.front.date-util :as date-util]
            [core.front.event :refer [<sub >evt]]
            [core.front.icons :as i]
            [core.front.session :as session]
            [core.user.model :as user-model]
            [core.util.util :as util]
            [potpuri.core :as p]
            [re-frame.core-instrumented :as rf]
            [reagent.core :as r]))


(rf/reg-event-fx ::init
  (fn [{:keys [db]} _]
    {:dispatch [::fetch-workspaces {:from 0}]
     :db       (-> db
                   (update ::state dissoc ::selected-workspace-id))}))


(rf/reg-event-fx ::open-direct-messages-after-init
  (fn [{:keys [db]} [_ recipient]]
    {:fx [[:dispatch [::set-conversation-tab 1]]
          [:dispatch [::set-direct-message-participants #{recipient (-> db :session/user :db/id)}]]]}))

(rf/reg-event-fx ::init-for-workspace
  (fn [{:keys [db]} [_ workspace-id conversations-visible? recipient]]
    (let [fetch-fx             [[:dispatch [::fetch-workspace-messages workspace-id]]
                                [:dispatch [::fetch-workspaces {:from 0}]]]
          open-conversation-fx (cond
                                 (nil? recipient)
                                 nil

                                 (:session/user db)
                                 [[:dispatch [::open-direct-messages-after-init recipient]]]

                                 :else
                                 [[:async-flow {:rules [{:when     :seen-any-of?
                                                         :events   [::session/restored-session]
                                                         :dispatch [::open-direct-messages-after-init recipient]
                                                         :halt?    true}]}]])]
      (merge
        (when conversations-visible?
          {:fx (vec (concat fetch-fx open-conversation-fx))})
        {:db (-> db
                 (update ::state
                         p/assoc-if
                         ::selected-workspace-id workspace-id
                         ::conversation-overlay-visible? conversations-visible?))}))))

(rf/reg-event-fx ::open-overlay-for-direct-msg
  (fn [{:keys [db]} [_ user-id attachment]]
    {:fx [[:dispatch [::fetch-workspace-messages (-> db ::state ::selected-workspace-id)]]
          [:dispatch [::fetch-workspaces {:from 0}]]]
     :db (-> db
             (update ::state
                     assoc
                     ::conversation-overlay-visible? true
                     ::conversation-tab 1
                     ::message-attachment attachment
                     ::selected-direct-message-participants #{user-id
                                                              (-> db
                                                                  :session/user
                                                                  :db/id)}))}))


(rf/reg-event-fx ::open-attachment
  (fn [_ [_ workspace-id entity]]
    {:route/push (p/deep-merge
                   :into
                   (case (:entity/type entity)

                     :entity.type/acceptance
                     (let [parent (acceptance-model/acceptance-parent entity)]
                       (case (:entity/type parent)
                         :entity.type/attachment
                         (let [review (-> parent :review/_attachments first)]
                           {:route (case (-> review :entity/parent :entity/type)
                                     :entity.type/application :view/application-attachments
                                     :entity.type/execution :view/execution-attachments
                                     :entity.type/pre-consultation :view/pre-consultation-attachments
                                     :view/workspace)
                            :query {:id (:db/id parent)}})

                         :entity.type/form
                         {:route  :view/form
                          :params {:form-id (:db/id parent)}}

                         {:route :view/workspace}))

                     {:route :view/workspace})
                   {:params {:workspace-id workspace-id}})}))


(rf/reg-event-db ::clear-attachment
  (fn [db [_]]
    (update db ::state dissoc ::message-attachment)))

;; new message adder, sub and setter
(rf/reg-event-fx ::add-new-message
  (fn [{:keys [db]} [_ message workspace-id thread-id recipients attachment]]
    (when (not (str/blank? message))
      {:db           (assoc-in db [::state ::message-send-pending?] true)
       :comm/command {:command    :conversation/add-message
                      :data       (merge {:conversation/text message
                                          :workspace-id      workspace-id}
                                         (when (some? thread-id)
                                           {:conversation-thread-id thread-id})
                                         (when (some? attachment)
                                           {:attachment-id attachment})
                                         (when (some? recipients)
                                           {:conversation-thread/private? true
                                            :conversation-thread/users    recipients}))
                      :on-success [::add-new-message.success workspace-id
                                   (or thread-id
                                       (some-> recipients set)
                                       workspace-id)]}})))


(rf/reg-event-fx ::add-new-message.success
  (fn [{:keys [db]} [_ workspace-id msg-draft-key status additional-entity-db]]
    {:db         (-> db
                     (update ::state dissoc ::message-send-pending?)
                     (assoc-in [::state ::reply-thread-id] nil))
     :dispatch-n (cond-> [[::entities/merge-entity-db status additional-entity-db]
                          [::set-new-message-text msg-draft-key ""]
                          [::clear-attachment]]
                   workspace-id
                   (conj [::fetch-workspaces {:workspace-id workspace-id}]))}))


(rf/reg-event-fx ::delete-message
  (fn [_ [_ conversation-id]]
    {:comm/command {:command    :conversation/delete-message
                    :data       (util/mmap conversation-id)
                    :on-success [::entities/apply-changes]
                    :notify     {:success :conversation/deleted}}}))


(rf/reg-event-fx ::set-conversations-seen
  (fn [{:keys [db]} _]
    (when (-> db ::state ::seen-conversation-ids set?)
      {:comm/command {:command    :conversation/set-conversations-seen
                      :method     :post
                      :on-success [::set-conversations-seen.success (-> db ::state ::seen-conversation-ids)]
                      :data       {:conversation-ids (-> db ::state ::seen-conversation-ids)}}})))


(rf/reg-event-fx ::set-conversations-seen.success
  (fn [{:keys [db]} [_ seen-ids status resp]]
    {:db         (-> db
                     (update-in [::state ::conversation-data]
                                (fn [conversation-data]
                                  (->> conversation-data
                                       (map (fn [c]
                                              (-> c
                                                  (update :not-seen (fn [current]
                                                                      (set/difference (or current #{}) seen-ids)))
                                                  (update :private-not-seen (fn [current]
                                                                              (set/difference (or current #{}) seen-ids)))))))))
                     (update-in [::state ::seen-conversation-ids] #(set/difference % seen-ids)))
     :dispatch-n [[::entities/apply-changes status resp]
                  [:app.front.root/fetch-conversation-notification-count false]]}))


(rf/reg-event-fx ::set-conversation-seen
  (fn [{:keys [db]} [_ conversation-id]]
    (let [ids #{conversation-id}]
      {:db                (update-in db [::state ::seen-conversation-ids] #(into (set %) ids))
       :dispatch-debounce {:id      ::set-conversations-seen
                           :timeout 2000
                           :action  :dispatch
                           :event   [::set-conversations-seen]}})))

(rf/reg-event-fx ::set-conversations-seen-batch
  (fn [{:keys [db]} [_ conversation-ids]]
    (let [ids (->> conversation-ids (remove nil?) (into #{}))]
      (when (seq ids)
        {:db                (update-in db [::state ::seen-conversation-ids] #(into (set %) ids))
         :dispatch-debounce {:id      ::set-conversations-seen
                             :timeout 2000
                             :action  :dispatch
                             :event   [::set-conversations-seen]}}))))

(rf/reg-sub ::state :-> ::state)

(rf/reg-sub ::seen-conversation-ids
  :<- [::state]
  :-> ::seen-conversation-ids)

(rf/reg-sub ::new-message-text
  :<- [::state]
  (fn [state [_ id]]
    (get-in state [::new-message-drafts id])))


(rf/reg-event-db ::set-new-message-text
  (fn [db [_ id new-msg]]
    (if (str/blank? new-msg)
      (-> db
          (update-in [::state ::new-message-drafts] dissoc id))
      (assoc-in db [::state ::new-message-drafts id] new-msg))))


; selected thread fetcher, setter and sub
(rf/reg-event-fx ::fetch-workspace-messages
  (fn [_ [_ workspace-id]]
    (when workspace-id
      {:comm/command {:command    :conversation/get-workspace-messages
                      :data       {:workspace-id workspace-id}
                      :method     :get
                      :on-success [::fetch-workspace-messages.success]}})))


(rf/reg-event-fx ::fetch-workspace-messages.success
  (fn [{:keys [db]} [_ status {:keys [recipients recipient-user-ids entities]}]]
    (let [selected           (-> db
                                 ::state
                                 ::selected-direct-message-participants
                                 (set/intersection recipient-user-ids))
          no-recipient?      (every? #(= % (-> db :session/user :db/id)) selected)
          assignee           (->> recipients :assignee (conversation-model/with-roles [:assignee/assignee]))
          reviewers          (->> recipients :reviewers (conversation-model/with-roles [:review/assignee]))
          booked-inspectors  (->> recipients :booked-inspectors (conversation-model/with-roles [:inspection/inspector]))
          visited-inspectors (->> recipients :visited-inspectors (conversation-model/with-roles [:inspection/inspector]))
          party-recipients   (conversation-model/format-party-recipients (:party-recipients recipients))
          msg-initiators     (->> recipients :msg-initiators (conversation-model/with-roles [:conversation/participant]))]
      {:db       (-> db
                     (assoc :direct-message-recipients (conversation-model/format-recipients
                                                         (concat assignee
                                                                 reviewers
                                                                 booked-inspectors
                                                                 visited-inspectors
                                                                 party-recipients
                                                                 msg-initiators)))
                     (update ::state
                             (if no-recipient?
                               dissoc
                               assoc)
                             ::selected-direct-message-participants
                             selected))
       :dispatch [::entities/merge-entity-db status entities]})))


(rf/reg-event-fx ::fetch-workspace-entities
  (fn [_ [_ workspace-id]]
    {:comm/command {:command    :workspace/get
                    :data       {:workspace/id workspace-id
                                 :find-related [:entity.type/party
                                                :entity.type/inspection
                                                :entity.type/workspace]}
                    :on-success [::fetch-workspace-entities.success]}}))


(rf/reg-event-fx ::fetch-workspace-entities.success
  (fn [_ [_ status data]]
    {:dispatch [::entities/merge-entity-db status (-> data :entities)]}))


(rf/reg-event-fx ::set-all-conversations-seen
  (fn [_ _]
    {:comm/command {:command    :conversation/set-all-conversations-seen
                    :on-success [::set-all-conversations-seen.success]
                    :notify     {:success :conversation/marked-all-as-read}}}))


(rf/reg-event-fx ::set-all-conversations-seen.success
  (fn [{:keys [db]} [_ status data]]
    {:db       (-> db
                   (assoc :app.front.root/conversation-notification-count 0)
                   (update-in [::state ::conversation-data]
                              (partial map #(assoc % :not-seen #{}
                                                   :private-not-seen #{}))))
     :dispatch [::entities/apply-changes status data]}))


(rf/reg-sub ::workspace-conversation-threads
  :<- [::entities/context]
  :<- [::selected-workspace-list-item]
  (fn [[ctx {:keys [workspace]}] [_ private?]]
    (->> (entities/find-entities ctx {:entity/parent                (-> workspace :db/id)
                                      :entity/type                  :entity.type/conversation-thread
                                      :conversation-thread/private? private?})
         (sort-by :entity/created))))


(rf/reg-sub ::can-send-workspace-messages?
  :<- [::entities/entity-db]
  (fn [entity-db [_ workspace-eid]]
    (when workspace-eid
      (permissions/can-send-workspace-messages? workspace-eid (vals entity-db)))))


(defn same-db-ids? [a b]
  (= (:db/id a) (:db/id b)))

(defn new-message-count [threads]
  (reduce
    (fn [total, thread]
      (+ total
         (->> thread
              :entity/_parent
              (remove (fn [msg] (<sub [::msg-seen? (:db/id msg)])))
              count))) 0 threads))


(defn format-roles [tr roles]
  ;; `roles` can contain the same underlying role more than once (e.g. as
  ;; distinct party-role entities across phases/parties), so dedupe by the
  ;; resolved label before joining to avoid e.g. "Applicant, Applicant".
  (->> roles
       (map #(or (party-common/party-role-label %)
                 (tr [%])))
       (remove str/blank?)
       distinct
       (sort-by (fnil str/lower-case ""))
       (str/join ", ")))


(defn format-recipients [current-user recipients]
  (->> recipients
       (remove (partial same-db-ids? current-user))
       (map user-model/full-name)
       (str/join ", ")))


(rf/reg-sub ::new-message-counts
  :<- [::workspace-conversation-threads false]
  :<- [::workspace-conversation-threads true]
  (fn [[public-threads direct-threads]]
    [(new-message-count public-threads)
     (new-message-count direct-threads)]))


(rf/reg-sub ::message-send-pending?
  :<- [::state]
  :-> ::message-send-pending?)


(rf/reg-sub ::message-attachment
  :<- [::state]
  :-> ::message-attachment)


;; Application iD sub and setter
(rf/reg-sub ::selected-workspace-id
  :<- [::state]
  :-> ::selected-workspace-id)


(rf/reg-event-db ::set-selected-workspace-id
  (fn [db [_ workspace-id]]
    (-> db
        (update ::state assoc ::selected-workspace-id workspace-id))))


;; Thread list setter, sub, fetcher
(rf/reg-event-db ::set-conversation-data
  (fn [db [_ from status {:keys [workspaces total-count]}]]
    (when (= status 200)
      (cond
        ;; `:from 0` → fresh load (initial, search, filter change): replace list
        ;; and the total count.
        (zero? (or from -1))
        (-> db
            (assoc-in [::state ::conversation-data] workspaces)
            (update ::state assoc ::conversation-total-count total-count))

        ;; `:from > 0` (pagination): append new page, dedupe by workspace id, and
        ;; update the total count.
        (and from (pos? from))
        (-> db
            (update-in [::state ::conversation-data]
                       (fn [existing-wss]
                         (let [ids (set (map (comp :workspace/id :workspace) workspaces))]
                           (-> (remove #(->> % :workspace :workspace/id (contains? ids))
                                       existing-wss)
                               (concat workspaces)))))
            (update ::state assoc ::conversation-total-count total-count))

        ;; `nil` → single-workspace upsert (e.g. after sending a message).
        ;; Update the workspace in place to preserve its position in the list,
        ;; or prepend it if it is not yet present. Do NOT touch the total count,
        ;; since this response only reports a count for the single workspace.
        :else
        (update-in db [::state ::conversation-data]
                   (fn [existing-wss]
                     (let [by-id     (into {} (map (juxt (comp :workspace/id :workspace) identity)) workspaces)
                           existing? (set (map (comp :workspace/id :workspace) existing-wss))
                           updated   (map (fn [ws]
                                            (or (get by-id (-> ws :workspace :workspace/id)) ws))
                                          existing-wss)
                           new-wss   (remove #(-> % :workspace :workspace/id existing?) workspaces)]
                       (concat new-wss updated))))))))


(defn compare-thread-ts
  [{{ts1 :entity/created} :latest-message} {{ts2 :entity/created} :latest-message}]
  (> ts1 ts2))


(rf/reg-sub ::conversation-data
  :<- [::state]
  (fn [state _]
    (some->> state
             ::conversation-data
             (sort compare-thread-ts))))


(rf/reg-sub ::conversation-total-count
  :<- [::state]
  :-> ::conversation-total-count)


(rf/reg-sub ::current-workspace-count
  :<- [::conversation-data]
  count)


(rf/reg-sub ::can-load-more?
  :<- [::current-workspace-count]
  :<- [::conversation-total-count]
  (fn [[current-count total-count]]
    (and (some? total-count) (< current-count total-count))))


(rf/reg-event-fx ::fetch-workspaces
  (fn [_ [_ data]]
    {:comm/command (p/assoc-if {:command    :conversation/get-workspaces
                                ;; Forward `:from` so `::set-conversation-data` can
                                ;; tell a fresh load (replace) from a load-more
                                ;; (append) or single-workspace upsert.
                                ;; - `:from 0` → replace the list (fresh load / filter change)
                                ;; - `:from N` (N > 0) → append (pagination)
                                ;; - `nil` → upsert / merge (single workspace refresh)
                                :on-success [::set-conversation-data (:from data)]}
                               :data data)}))


(rf/reg-event-fx ::refresh-thread
  (fn [{{{::keys [selected-workspace-id
                  conversation-overlay-visible?]} ::state :as db} :db} _]
    (cond
      (and conversation-overlay-visible? selected-workspace-id)
      {:fx [[:dispatch [::fetch-workspace-messages selected-workspace-id]]
            [:dispatch [::fetch-workspaces {:workspace-id selected-workspace-id}]]]}

      (-> db :route/match :data :name (= :view/conversations))
      {:dispatch [::fetch-workspaces {:from 0}]})))


(rf/reg-sub ::loading?
  :<- [::conversation-data]
  :-> nil?)


(rf/reg-sub ::selected-workspace-list-item
  :<- [::selected-workspace-id]
  :<- [::conversation-data]
  :<- [::entities/context]
  (fn [[workspace-id data ctx]]
    (or (-> data
            (p/find-first #(-> % :workspace :workspace/id (= workspace-id))))
        (some->> workspace-id
                 (hash-map :workspace/id)
                 (entities/find-entity ctx)
                 (hash-map :workspace)))))


;; link to workspace
(rf/reg-event-fx ::open-workspace
  (fn [_ [_ workspace-id]]
    {:route/push {:route :view/workspace :params {:workspace-id workspace-id}}}))


;; toggle conversation overlay and fetch messages if needed
(rf/reg-event-fx ::toggle-conversation-overlay
  (fn [{:keys [db]} [_ visible? workspace-id]]
    (let [visible?     (if (nil? visible?)
                         (-> db ::state ::conversation-overlay-visible? not)
                         visible?)
          workspace-id (if (nil? workspace-id)
                         (-> db ::state ::selected-workspace-id)
                         workspace-id)]
      (merge {:db (-> db
                      (update ::state assoc ::conversation-overlay-visible? visible?)
                      (update ::state dissoc ::selected-direct-message-participants))}
             (when visible?
               {:dispatch-n [[::fetch-workspaces {:workspace-id workspace-id}]
                             [::fetch-workspace-messages workspace-id]]})))))


(rf/reg-sub ::conversation-overlay-visible?
  :<- [::state]
  #(get % ::conversation-overlay-visible? false))


(rf/reg-sub ::users-in-conversation
  :<- [::workspace-conversation-threads false]
  (fn [threads _]
    (->> threads
         (mapcat :entity/_parent)
         (map (fn [msg]
                [(-> msg :entity/creator user-model/full-name)
                 (:conversation/by-authority? msg)]))
         distinct
         (sort-by first))))


(rf/reg-event-db ::set-reply-thread-id
  (fn [db [_ thread-id]]
    (-> db
        (update ::state assoc ::reply-thread-id thread-id))))


(rf/reg-sub ::reply-thread-id
  :<- [::state]
  :-> ::reply-thread-id)


(rf/reg-sub ::conversation-tab
  :<- [::state]
  #(get % ::conversation-tab 0))


(rf/reg-event-fx ::set-conversation-tab
  (fn [{:keys [db]} [_ tab-index]]
    {:dispatch [::clear-attachment]
     :db       (update db ::state assoc ::conversation-tab tab-index)}))




(rf/reg-sub ::direct-message-recipients
  :-> :direct-message-recipients)


(rf/reg-sub ::available-direct-message-recipients
  :<- [::direct-message-recipients]
  :<- [:session/user]
  (fn [[recipients current-user]]
    (dissoc recipients (:db/id current-user))))


(rf/reg-sub ::available-direct-message-recipient-options
  :<- [::available-direct-message-recipients]
  (fn [available-recipients]
    (->> available-recipients
         vals
         (map (fn [recipient]
                [(-> recipient :user :db/id)
                 (-> recipient :user user-model/full-name)
                 (-> recipient :roles vec)
                 (:business recipient)])))))


(defn recipient-label [lang tr [id name roles business]]
  (let [name (cond-> name
               business (str " - " (business-model/business-name business lang)))]
    [id (str name " (" (format-roles tr roles) ")")]))


(rf/reg-event-db ::set-direct-message-participants
  (fn [db [_ participant-ids]]
    (-> db
        (update ::state assoc ::selected-direct-message-participants participant-ids))))


(rf/reg-sub ::selected-direct-message-participants
  :<- [::state]
  :-> ::selected-direct-message-participants)

(rf/reg-sub ::selected-direct-message-recipients
  :<- [::selected-direct-message-participants]
  :<- [:session/user]
  (fn [[participants user]]
    (->> participants (remove #(= % (:db/id user))))))


;; TODO maybe check if participant has authority role on the CURRENT workspace?
(defn authority? [user]
  (not-empty (:user/groups user)))


(defn direct-conversation-inactive? [current-user available-recipients participants]
  (->> participants
       (remove (partial same-db-ids? current-user))
       (not-any? (fn [participant]
                   (or
                     (contains? available-recipients (:db/id participant))
                     (authority? participant))))))


(rf/reg-sub ::direct-conversations-by-category
  :<- [::workspace-conversation-threads true]
  :<- [::available-direct-message-recipients]
  :<- [:session/user]
  (fn [[threads available-recipients user]]
    (let [current-user? (partial same-db-ids? user)]
      (->> threads
           (group-by :conversation-thread/users)
           seq
           (map (fn [[participants threads]]
                  {:participants      participants
                   :threads           threads
                   :new-message-count (new-message-count threads)}))
           (group-by #(cond
                        ; Authority users should see direct conversations by other authorities too:
                        (->> % :participants (not-any? current-user?)) :not-participating
                        ; Conversations with recipients that are not available anymore (removed parties etc):
                        (->> % :participants (direct-conversation-inactive? user available-recipients)) :inactive
                        ; Conversations with new messages:
                        (-> % :new-message-count zero? not) :new-messages
                        :else :other))))))


(rf/reg-sub ::direct-conversation-inactive?
  :<- [::conversation-tab]
  :<- [::direct-conversations-by-category]
  :<- [::selected-direct-message-participants]
  (fn [[tab conversations-by-category participants]]
    (and (= tab 1)
         (->> (select-keys conversations-by-category [:not-participating :inactive])
              vals
              (apply concat)
              (map :participants)
              (some #(= (->> % vec (map :db/id) set) (set participants)))
              boolean))))


(rf/reg-sub ::direct-conversation-threads
  :<- [::workspace-conversation-threads true]
  :<- [::selected-direct-message-participants]
  (fn [[threads participants]]
    (get (->> threads (group-by #(->> % :conversation-thread/users vec (map :db/id) set))) participants [])))


(rf/reg-sub ::recipient-info-from-threads
  :<- [::direct-conversation-threads]
  (fn [threads [_ recipient-id]]
    (some->> threads
             (some #(p/find-first (-> % :conversation-thread/users vec) {:db/id recipient-id}))
             (#(assoc {:roles (if (authority? %) #{:conversation/authority} #{})} :user %)))))


(rf/reg-sub ::msg-seen?
  :<- [::entities/entity-db]
  :<- [:session/user]
  (fn [[entity-db user] [_ msg-id]]
    (-> (get-in entity-db [msg-id :conversation/unseen-users])
        (contains? (:db/id user))
        not)))

(rf/reg-sub ::msg-seen-pending?
  :<- [::seen-conversation-ids]
  (fn [pending-seen [_ msg-id]]
    (contains? pending-seen msg-id)))

(defn workspace-list-item [{:keys [workspace municipality message-count not-seen latest-message]} selected? tr]
  [:div {:class-name (str "message-list-item" (when selected? " active arrow_box arrow_box_right"))
         :key        (str "message-list-item-" (:workspace/id workspace))
         :on-click   #(do
                        (>evt [::fetch-workspace-messages (:workspace/id workspace)])
                        (>evt [::set-selected-workspace-id (:workspace/id workspace)])
                        (>evt [::fetch-workspace-entities (:workspace/id workspace)])
                        (>evt [::set-direct-message-participants nil]))}
   (when (> (count not-seen) 0)
     [:div.cloudpermit--notification-badge
      {:style {:right "15px" :top "50%" :margin-top "-8px"}}
      (count not-seen)])
   [:div.p-4.pr-10
    [:h5.inline-block (str (or (:workspace/address workspace)
                               (-> workspace :workspace/primary-property :property/id))
                           ", " municipality)]
    [:p.p-0
     (if (= 0 message-count)
       (tr [:conversation/application-has-no-messages])
       (tr [:conversation/last-message-by]
           [(-> latest-message :entity/creator user-model/full-name)
            ((<sub [::date-util/date-time-fn]) (-> latest-message :entity/created))]))]]])


(defn workspace-list [tr threads]
  (let [selected-id (<sub [::selected-workspace-id])
        ws-count    (<sub [::current-workspace-count])]
    [:div.flex.flex-auto.flex-col
     [:div.message-list-selector.mb-2.flex.flex-col.xxl:flex-row.xxl:items-center
      {:style {:width "90%"}}
      [:span.message-types-selector.flex-1.py-1
       [:b (tr [:conversation/public-conversations]) " (" (count threads) ")"]]
      (when (some #(-> % :not-seen not-empty) threads)
        (cc/link {:class-name "cursor-pointer"
                  :on-click   #(>evt [::set-all-conversations-seen])}
                 (tr [:conversation/mark-all-as-read])))]
     [:div.message-list-applications.message-list-scroller.overflow-y-scroll.flex-auto
      (for [{:keys [workspace] :as item} threads
            :let                         [selected? (= selected-id (:workspace/id workspace))]]
        ^{:key (str "thread-item-" (:workspace/id workspace))}
        [workspace-list-item item selected? tr])
      (when (<sub [::can-load-more?])
        [:div.flex.justify-center.pr-10
         [:div.cursor-pointer.p-4.flex.flex-col.items-center
          {:on-click #(>evt [::fetch-workspaces {:from ws-count}])}
          (cc/icon {:icon        i/refresh
                    :class-name  "mb-4"
                    :description ""})
          [:span.semibold (tr [:conversation/load-more])]]])]]))


(defn is-mac? []
  (str/includes? (.-userAgent js/navigator) "Mac OS X"))


(defn quick-send-shortcut-tip [tr]
  (str (if (is-mac?) "[CMD]" "[CTRL]") " + [ENTER] " (tr [:conversation/quick-send-shortcut-tip])))


(defn auto-resize [e]
  (let [textarea  (.-target e)
        parent-el (.-parentElement textarea)
        height    (str (.-scrollHeight textarea) "px")]
    (js/setTimeout (fn []
                     (set! (.-height (.-style textarea)) "auto")
                     (set! (.-height (.-style textarea)) height)
                     (set! (.-height (.-style parent-el)) height)) 1)))


(defn ctrl-pressed? [e]
  ; CMD for Mac, CTRL for PC
  (if (is-mac?) (.-metaKey e) (.-ctrlKey e)))


(defn get-quick-send-handler [submit-handler disabled?]
  (fn [e]
    (when (and (ctrl-pressed? e) (futil/enter-press? e) (not disabled?))
      (submit-handler e))))


(defn get-submit-handler [message workspace-id thread-id participants attachment]
  (fn [e]
    (let [pending? (<sub [::message-send-pending?])]
      (.preventDefault e)
      (when-not pending?
        (>evt [::add-new-message message workspace-id thread-id participants attachment])))))


(defn conversation-participant-role [role]
  [:span.bg-blue-600.text-white.inline-block.px-4.py-1.uppercase.text-xs.mx-2.rounded-full.font-normal role])


(defn empty-description [message]
  [:div.flex-1.flex.flex-row.text-xl.text-gray-400.items-center.justify-center.p-8.pb-24.leading-normal.text-center
   [:span message]])


(defn reply-thread-input [_ _ scroller-ref recipients]
  (let [*ref             (atom nil)
        scroll-into-view #(when scroller-ref
                            (.scrollTo scroller-ref
                                       #js{:top      (- (.-offsetTop @*ref) (/ (.-clientHeight scroller-ref) 2))
                                           :behavior "smooth"})
                            nil)]
    (r/create-class
      {:component-did-mount scroll-into-view
       :reagent-render      (fn [tr thread-id _]
                              (let [message        (<sub [::new-message-text thread-id])
                                    workspace-id   (<sub [::selected-workspace-id])
                                    pending?       (<sub [::message-send-pending?])
                                    inactive?      (<sub [::direct-conversation-inactive?])
                                    submit-handler (get-submit-handler message workspace-id thread-id recipients nil)
                                    disabled?      (or (zero? (count message)) (boolean pending?) inactive?)]
                                [:form.new-message-input-container.flex.justify-between.pt-4
                                 {:ref       #(reset! *ref %)
                                  :on-submit submit-handler}
                                 [:div.textarea-container
                                  [ui/text-area
                                   {:id          "reply-thread-input"
                                    :input-class "rounded reply-message-input border-ui-violet-50 border border-solid pt-3.5"
                                    :label-text  (tr [:conversation/new-conversation-message])
                                    :hide-label  true
                                    :rows        1
                                    :value       message
                                    :on-change   #(rf/dispatch-sync [::set-new-message-text thread-id (-> % .-target .-value)])
                                    :on-key-up   auto-resize
                                    :on-blur     auto-resize
                                    :on-key-down (get-quick-send-handler submit-handler disabled?)
                                    :placeholder (tr [:conversation/reply])
                                    :auto-focus  true
                                    :key         workspace-id}]
                                  (when (< 0 (count message))
                                    (cc/button {:href             "#"
                                                :class-name       "w-auto justify-start absolute top-1 right-0 m-1"
                                                :size             :small
                                                :kind             :ghost
                                                :icon             i/remove
                                                :icon-description ""
                                                :on-click         #(rf/dispatch-sync [::set-new-message-text thread-id ""])}
                                               (tr [:clear])))]
                                 [:div.button-container.self-stretch.flex.flex-row.align-stretch.relative.ml-2
                                  (cc/button
                                    {:kind             :primary
                                     :type             :submit
                                     :icon             i/arrow-right
                                     :icon-description (tr [:conversation/send-message])
                                     :disabled         disabled?
                                     :class-name       "only-icon-button-wide"}
                                    nil)
                                  (when pending?
                                    [:div.message-send-pending
                                     (cc/inline-loading {})])]]))})))

(defn message-attachment [entity sent? tr lang]
  (let [workspace-id (<sub [::selected-workspace-id])]
    [:div.flex.justify-between
     {:class "rounded bg-gray-200 px-3.5 py-3.5 overflow-y-scroll"
      :style {:max-height "200px"}}
     (if entity
       (case (:entity/type entity)
         :entity.type/sub-review
         [:div
          [:div.bold.mb-3.5
           (-> entity :entity/parent (review-model/review-name lang))]
          [ui-rt/editor-legacy
           {:initial-value (:sub-review/comment entity)}]]

         :entity.type/acceptance
         [:div
          [ui-rt/editor-legacy
           {:initial-value (:acceptance/text entity)}]])
       (tr [:conversation/insufficient-read-permissions]))

     (when (and sent? entity)
       [:a.no-underline.uppercase.text-xs
        {:href     "#"
         :on-click #(>evt [::open-attachment workspace-id entity])}
        (tr [:dashboard-search/go-to-ws])])]))


(defn new-message-input [tr participants]
  (let [direct?        (some? participants)
        attachment     (<sub [::message-attachment])
        lang           (<sub [:language])
        workspace-id   (<sub [::selected-workspace-id])
        msg-draft-key  (if direct? (set participants) workspace-id)
        message        (<sub [::new-message-text msg-draft-key])
        pending?       (<sub [::message-send-pending?])
        submit-handler (get-submit-handler message workspace-id nil participants (:db/id attachment))
        inactive?      (<sub [::direct-conversation-inactive?])
        disabled?      (or (zero? (count message)) (boolean pending?) inactive?)]
    [:div
     {:class "new-message-input-container bg-blue-100 rounded border-blue-200 border border-solid pt-3.5"}
     (when attachment
       [:div.flex.justify-between.px-4
        [:div.flex-grow.1
         [message-attachment attachment false tr lang]]
        [:div.button-container.self-stretch.flex.flex-row.align-stretch.relative.ml-2
         (cc/button {:size             :small
                     :disabled         false
                     :type             :button
                     :kind             :ghost
                     :icon             i/remove
                     :icon-description (tr [:conversation/clear-attachment])
                     :class-name       "only-icon-button-wide"
                     :on-click         #(rf/dispatch-sync [::clear-attachment])}
                    nil)]])
     [:form.flex.justify-between.px-4.pt-2.pb-8
      {:on-submit submit-handler}
      [:div.textarea-container
       [ui/text-area
        {:id          "new-message-input"
         :label-text  (tr [:conversation/new-conversation-message])
         :hide-label  true
         :light       true
         :rows        1
         :value       message
         :on-change   #(rf/dispatch-sync [::set-new-message-text msg-draft-key (-> % .-target .-value)])
         :on-key-up   auto-resize
         :on-blur     auto-resize
         :on-key-down (get-quick-send-handler submit-handler disabled?)
         :placeholder (tr [:conversation/write-new-message-here])
         :auto-focus  true
         :key         workspace-id}]
       [:div.message-quick-send-tip
        (quick-send-shortcut-tip tr)]
       (when (< 0 (count message))
         (cc/button {:href             "#"
                     :class-name       "w-auto justify-start absolute top-1 right-0 m-1"
                     :size             :small
                     :kind             :ghost
                     :icon             i/remove
                     :icon-description ""
                     :on-click         #(rf/dispatch-sync [::set-new-message-text msg-draft-key ""])}
                    (tr [:clear])))]
      [:div.button-container.self-stretch.flex.flex-row.align-stretch.relative.ml-2
       (cc/button
         {:kind             :primary
          :type             :submit
          :icon             i/arrow-right
          :icon-description (tr [:conversation/send-message])
          :disabled         disabled?
          :class-name       "only-icon-button-wide"}
         nil)
       (when pending?
         [:div.message-send-pending
          (cc/inline-loading {})])]]]))


(defn new-message-indicator [{:keys [tr msg-id is-reply?]}]
  (when-not (<sub [::msg-seen? msg-id])
    (let [seen-pending? (<sub [::msg-seen-pending? msg-id])]
      [t/fade-out-up
       {:in (not seen-pending?)}
       [:div.absolute.-mt-3.text-ui-red-100.uppercase.text-xs.flex.flex-col.items-center.cursor-pointer
        {:style {:top  "50%"
                 :left (if is-reply? "-4.2rem" "-2.2rem")}}
        [:div.bg-ui-red.w-2.h-2.mb-2.rounded-full]
        [:div.leading-3 (tr [:conversation/new])]]])))


(defn conversation-message [msg tr is-reply? can-reply?]
  (let [inactive?   (<sub [::direct-conversation-inactive?])
        lang        (<sub [:language])
        msg-id      (:db/id msg)
        seen?       (<sub [::msg-seen? msg-id])
        user        (<sub [:session/user])
        my-message? (= (:db/id user) (:db/id (:entity/creator msg)))
        date-str    ((<sub [::date-util/date-time-fn]) (:entity/created msg))
        author-str  (if my-message?
                      (tr [:conversation/you])
                      (user-model/full-name (:entity/creator msg)))
        deleted?    (du/in-state? :conversation.state/deleted msg)]
    [:div
     {:class (if (:conversation/by-authority? msg)
               "message-item-authority"
               "message-item")}
     [:> InView
      {:as        "div"
       :threshold 1
       :on-change (fn [in-view?]
                    (when (and in-view?
                               (not seen?)
                               (some-> msg :db/id))
                      (>evt [::set-conversation-seen (:db/id msg)])))}
      (r/as-element
        [:div.top-row
         [:span.author
          author-str
          (when (:conversation/by-authority? msg) [conversation-participant-role (tr [:conversation/authority])])]
         [:span.message-time.font-bold date-str]])]
     [:div.message-text.relative
      (when (contains? msg :conversation/attachment)
        [message-attachment (:conversation/attachment msg) true tr lang])
      [:div.mb-2
       (if deleted?
         [:span.text-ui-dark-gray.font-bold (tr [:conversation/deleted])]
         (:conversation/text msg))]
      (when (and (not inactive?) can-reply?)
        [:a.no-underline.uppercase.text-xs
         {:href     "#"
          :on-click #(>evt [::set-reply-thread-id (-> msg :entity/parent :db/id)])}
         [:span.mr-2 (tr [:conversation/reply])]
         (cc/icon {:icon        i/rotate-left
                   :description ""
                   :fill        "currentcolor"
                   :height      "10"
                   :width       "10"})])
      (when (and (not deleted?)
                 (<sub [:session/admin?]))
        [ui/modal-confirmation-button
         {:id                  (str "remove-mesage-" (:db/id msg))
          :tr                  tr
          :trigger-button-text (tr [:conversation/delete])
          :trigger-button-opts {:kind       :ghost
                                :icon       i/trash
                                :class-name "text-xs p-0 m-0 text-blue-600 border-0 font-normal min-h-0 my-1 ml-4 rounded-none"}
          :dangerous?          true
          :on-yes-click        #(>evt [::delete-message (:db/id msg)])}
         [:span (tr [:conversation/delete-confirm] [date-str author-str])]])
      [new-message-indicator (util/mmap tr is-reply? msg-id)]]]))


(defn conversation-phase-header [phase current? class]
  [:a.block.w-full.bg-ui-blue-10.text-ui-blue-80.font-bold.text-center.uppercase.no-underline.p-2.border-solid.border-b.border-t.border-white.hover:bg-ui-blue-20
   {:class (cs class
               (when current? "bg-ui-violet-100 text-white"))
    :href  "#"}
   [:span.mr-2 phase]
   (when-not current? (cc/icon {:icon        i/plus
                                :description ""
                                :fill        "currentcolor"
                                :height      "10"
                                :width       "10"}))])

(defn conversation-threads [{:keys [tr viewport-ref can-participate?]} threads]
  (let [reply-thread-id (<sub [::reply-thread-id])]
    (for-frag [thread threads]
      (let [msgs (->> thread
                      :entity/_parent
                      (sort-by :entity/created))]
        [:div {:id (str "message-thread-" (:db/id thread))}
         [conversation-message (first msgs) tr false can-participate?]
         [:div.ml-4.pl-4.border-l.border-solid.border-gray-400
          (for-frag [msg (rest msgs)]
            ^{:key (str "message-item-" (:db/id msg))}
            [conversation-message msg tr true can-participate?])
          (when (= reply-thread-id (:db/id thread))
            [reply-thread-input tr reply-thread-id viewport-ref nil])]]))))

(defn single-conversation-view [_ _ _]
  (let [*ref          (r/atom nil)
        scroll-to-end (fn []
                        (set! (.-scrollTop @*ref) (.-scrollHeight @*ref)))
        on-update     (fn [this old-args]
                        ; Scroll only when a new thread has been added
                        (when (not= (count (second old-args)) (count (second (r/argv this))))
                          (scroll-to-end)))]
    (r/create-class
      {:component-did-update on-update
       :component-did-mount  scroll-to-end
       :reagent-render       (fn [threads can-participate? tr]
                               (let [threads-by-phases (group-by :conversation-thread/workspace-state threads)]
                                 [sticky/scroller {:class "message-thread-content flex-auto"
                                                   :ref   (fn [el] (reset! *ref el))}
                                  (for-frag [phase workspace-model/workspace-states]
                                    (let [phase-threads (get threads-by-phases phase)]
                                      (when (not-empty phase-threads)
                                        [:<>
                                         [sticky/sticky {:style {:z-index 49}}
                                          [conversation-phase-header (tr [phase]) false ""]]
                                         [:div.pl-10.pr-4.pt-2.pb-16
                                          [conversation-threads (util/mmap {:viewport-ref @*ref} tr can-participate?)
                                           (get threads-by-phases phase)]]])))]))})))


(defn direct-conversation [_ _ _]
  (let [*ref          (r/atom nil)
        set-ref       (fn [el] (reset! *ref el))
        scroll-to-end (fn []
                        (set! (.-scrollTop @*ref) (.-scrollHeight @*ref)))
        on-update     (fn [this old-args]
                        ;; Scroll only when a new thread has been added
                        (when (not= (count (second old-args)) (count (second (r/argv this))))
                          (scroll-to-end)))]
    (r/create-class
      {:component-did-update on-update
       :component-did-mount  scroll-to-end
       :reagent-render       (fn [threads can-participate? tr]
                               (when (not-empty threads)
                                 [:div.message-thread-content.overflow-y-scroll.pl-10.pr-4.pt-2.pb-16.flex-auto
                                  {:ref set-ref}
                                  [conversation-threads (util/mmap {:viewport-ref @*ref} tr can-participate?)
                                   threads]]))})))


(defn recipient-selector [tr]
  (let [available-recipients (<sub [::available-direct-message-recipient-options])
        user                 (<sub [:session/user])
        lang                 (<sub [:language])]
    [:div.flex.flex-row.items-center
     [:select.border.border-solid.border-ui-violet-100.px-4.rounded-md.h-10.flex-1.bg-ui-violet-100.hover:bg-ui-violet-90.text-white.max-w-xs
      {:on-change #(>evt [::set-direct-message-participants #{(:db/id user) (-> % tval parse-int)}])}
      [:option {:value ""} (tr [:conversation/select-recipient])]
      (for-frag [[id label] (map (partial recipient-label lang tr) available-recipients)]
        [:option {:value id}
         label])]]))


(defn direct-conversation-header [tr user participant-ids]
  (r/with-let [*info-open? (r/atom false)]
    (let [; Take the first participant that is not the current user because only 1-to-1 direct conversations are supported for now:
          recipient-id         (->> participant-ids (remove #(= % (:db/id user))) first)
          available-recipients (<sub [::available-direct-message-recipients])
          recipient            (or
                                 (get available-recipients recipient-id)
                                 ; In some cases users might get direct messages from users that are not in the list
                                 ; of available recipients so we need to find the info from the messages:
                                 (<sub [::recipient-info-from-threads recipient-id]))]
      [:<>
       [:div.bg-ui-light-gray.flex.flex-row.items-center
        (cc/button {:href             "#"
                    :class-name       "w-auto justify-start"
                    :kind             :ghost
                    :icon             i/arrow-left
                    :icon-description ""
                    :icon-position    :left
                    :on-click         #(>evt [::set-direct-message-participants nil])}
                   (tr [:back]))
        [:div.flex.flex-1.flex-row.justify-center.text-center.font-bold.pr-4
         (user-model/full-name (:user recipient))]
        (cc/button {:href             "#"
                    :class-name       "w-auto justify-start"
                    :kind             :ghost
                    :icon             (if @*info-open? i/minus i/plus)
                    :icon-description ""
                    :on-click         #(reset! *info-open? (not @*info-open?))}
                   (tr [:conversation/info]))]
       (when @*info-open?
         [:div.bg-ui-light-gray.p-4.pt-2.flex.flex-row.items-center.justify-center.text-center
          [:div.flex.flex-row.items-center.justify-center.text-center.font-bold
           (format-roles tr (:roles recipient))]])])))


(defn direct-conversation-item [_ user {:keys [participants new-message-count]}]
  [:a.border.border-solid.border-gray-400.mb-2.p-2.rounded-lg.h-10.flex.flex-row.items-center.hover:bg-ui-violet-10.no-underline
   {:href     "#"
    :on-click #(>evt [::set-direct-message-participants (->> participants (map :db/id) set)])}
   (when-not (zero? new-message-count)
     [:div.border.border-solid.border-ui-violet-100.w-8.text-center.py-1.rounded-sm.font-bold.text-ui-violet-100 new-message-count])
   [:span.font-bold.text-ui-night-sky.ml-2 (format-recipients user participants)]])


(defn direct-conversation-category [tr user title conversations]
  (when (not-empty conversations)
    [:div
     [:h3.font-bold.text-lg.text-ui-night-sky.py-4 title]
     (into [:div]
           (->> conversations
                (map (partial direct-conversation-item tr user))))]))


(defn direct-conversation-list [tr user conversations-by-category]
  [:div.pt-0.pb-4.px-4
   [direct-conversation-category tr user (tr [:conversation/new-messages]) (:new-messages conversations-by-category)]
   [direct-conversation-category tr user (tr [:conversation/current-discussions]) (:other conversations-by-category)]
   [direct-conversation-category tr user (tr [:conversation/inactive-discussions]) (:inactive conversations-by-category)]
   [direct-conversation-category tr user (tr [:conversation/not-participating]) (:not-participating conversations-by-category)]])


(defn direct-conversation-disclaimer [tr]
  (r/with-let [*visible? (r/atom false)]
    [:div.px-4.pt-2
     [:button.bg-transparent.border-0.text-ui-night-sky-100
      {:on-click #(swap! *visible? not)}
      (tr [:conversation/direct-conversation-visibility-link])]
     [t/transition
      {:transition "dispatch-slide-down"
       :timeout    200
       :in         @*visible?}
      [:div.bg-ui-light-gray.p-2.rounded.mt-2.leading-tight.text-xs
       (tr [:conversation/direct-conversation-visibility-desc])]]]))


(def ^:private context-type-missing-workspace-tr-keys
  {:workspace     :conversation/unauthorized
   :conversations :conversation/please-select-application})


(defn- direct-workspace-conversation-view [tr user context-type workspace show-recipient-selector?]
  (let [selected-participants     (<sub [::selected-direct-message-participants])
        conversation-threads      (<sub [::direct-conversation-threads])
        conversations-by-category (<sub [::direct-conversations-by-category])
        all-direct-threads        (<sub [::workspace-conversation-threads true])
        recipient-ids             (<sub [::selected-direct-message-recipients])
        inactive?                 (<sub [::direct-conversation-inactive?])
        participating?            (contains? (set selected-participants) (:db/id user))
        can-participate?          (<sub [::can-send-workspace-messages? (:db/id workspace)])]
    (if (nil? workspace)
      [:div.message-thread-placeholder (tr [(context-type-missing-workspace-tr-keys context-type)])]
      (if (some? selected-participants)
        [:div.flex.flex-col.flex-auto
         [direct-conversation-header tr user selected-participants]
         (if (seq conversation-threads)
           [direct-conversation conversation-threads can-participate? tr]
           [:div.flex-auto.flex.flex-col.justify-center.items-center
            [empty-description (tr [:conversation/direct-conversation-has-no-messages])]])
         (if (or inactive? (not can-participate?))
           [:div.flex.justify-between.p-4.pb-6.bg-blue-100.leading.text-gray-700.leading-normal
            (tr [(cond (not can-participate?) :conversation/read-only-description
                       (not participating?) :conversation/not-participating-description
                       :else :conversation/inactive-description)])]
           [new-message-input tr recipient-ids])]
        [:div.flex.flex-col.flex-auto.mt-2
         (when (and show-recipient-selector? can-participate?) [:div.px-4.pt-2 [recipient-selector tr]])
         [direct-conversation-disclaimer tr]
         (if (empty? all-direct-threads)
           [empty-description (tr [:conversation/no-direct-conversations])]
           [direct-conversation-list tr user conversations-by-category])]))))


(defn- public-workspace-conversation-view [tr context-type workspace]
  (let [conversation-threads (<sub [::workspace-conversation-threads false])
        loading?             (<sub [::loading?])
        can-participate?     (<sub [::can-send-workspace-messages? (:db/id workspace)])]
    (cond
      loading?
      [:div.m-4.flex
       (cc/inline-loading {:description (tr [:conversation/loading])})]

      (nil? workspace)
      [:div.message-thread-placeholder (tr [(context-type-missing-workspace-tr-keys context-type)])]

      :else
      [:div.flex.flex-col.flex-auto
       (if (seq conversation-threads)
         [single-conversation-view conversation-threads can-participate? tr]
         [:div.flex-auto.flex.flex-col.justify-center.items-center
          [empty-description (tr [:conversation/application-has-no-messages])]])
       (if can-participate?
         [new-message-input tr nil]
         [:div.flex.justify-between.p-4.pb-6.bg-blue-100.leading.text-gray-700.leading-normal
          (tr [:conversation/read-only-description])])])))


(defn conversation-participants [tr]
  (let [users (<sub [::users-in-conversation])]
    (when-not (empty? users)
      [:<>
       [:div.flex.flex-row.text-center.justify-center.items-center.mt-2
        (cc/icon {:icon        i/persons
                  :class-name  "mr-2"
                  :description (tr [:conversation/participants] [(count users)])})
        [:h5 (tr [:conversation/participants] [(count users)])]]
       (into [:div.text-center.pt-2.px-4.pb-4]
             (interpose
               [:span ", "]
               (for [user users]
                 [:span
                  (first user)
                  (when (second user)
                    [conversation-participant-role (tr [:conversation/authority])])])))])))


(defn no-apps-message [tr]
  [:div.message-thread-placeholder {:dangerouslySetInnerHTML (r/unsafe-html (tr [:conversation/no-applications]))}])


(defn conversation-tabs [tr]
  (let [tab-index                   (<sub [::conversation-tab])
        [public-count direct-count] (<sub [::new-message-counts])]
    (cc/content-switcher
      {:selected-index tab-index
       :class-name     "m-4 w-auto"
       :on-change      #(>evt [::set-conversation-tab (-> % .-index)])}
      (cc/switch {:text (str (tr [:conversation/public]) (when (< 0 public-count) (str " (" public-count ")")))})
      (cc/switch {:text (str (tr [:conversation/direct]) (when (< 0 direct-count) (str " (" direct-count ")")))}))))


;; Messaging view for all applications
(defn conversations-view [_]
  (let [tr                    (<sub [:tr])
        user                  (<sub [:session/user])
        workspaces            (<sub [::conversation-data])
        selected-ws           (<sub [::selected-workspace-list-item])
        tab-index             (<sub [::conversation-tab])
        selected-participants (<sub [::selected-direct-message-participants])
        can-send-direct?      (<sub [::can-send-workspace-messages? (-> selected-ws :workspace :db/id)])]
    [:div.bx--grid.max.h-full.flex.flex-col.pt-10
     (if (<sub [::loading?])
       (cc/loading-spinner {})
       [:div.flex.flex-row.flex-auto
        [:div.pl-8.flex.flex-col.w-1-3>div.flex.flex-auto.flex-col
         [:div>h2
          (tr [:view/conversations])]
         [workspace-list tr workspaces]]
        [:div.message-thread.flex.flex-col
         (if (seq workspaces)
           [:<>
            (when (and (some? (:workspace selected-ws)) (nil? selected-participants))
              [:div.message-thread-header.flex.flex-row.items-center
               [:div.max-w-sm.w-full [conversation-tabs tr]]
               (when (and (> tab-index 0) can-send-direct?) [recipient-selector tr])
               [:div.flex-auto]
               [:a.mt-1.p-6.open-app-link {:on-click #(>evt [::open-workspace (:workspace/id (:workspace selected-ws))])}
                (tr [:conversation/open-application])]])
            (if (> tab-index 0)
              [direct-workspace-conversation-view tr user :conversations (:workspace selected-ws) false]
              [public-workspace-conversation-view tr :conversations (:workspace selected-ws)])]
           [no-apps-message tr])]])]))


;; Messaging overlay for single workspace
(defn application-conversation-overlay []
  (let [workspace-id (get-in (<sub [:route/match]) [:parameters :path :workspace-id])
        visible?     (<sub [::conversation-overlay-visible?])
        close-fn     #(>evt [::toggle-conversation-overlay false])
        selected-ws  (-> (<sub [::conversation-data])
                         (p/find-first #(-> % :workspace :workspace/id (= workspace-id))))
        tr           (<sub [::ws-subs/tr])
        user         (<sub [:session/user])
        tab-index    (<sub [::conversation-tab])]
    (when (and workspace-id visible?)
      [drawer/view (util/mmap {:title        (tr [:conversation/workspace-messages])
                               :full-height? true}
                              close-fn tr)
       (if (<sub [::ws-hidden-desc/hidden?])
         [:div.p-4
          [ws-hidden-desc/hidden-description-content (util/mmap tr)]]
         [:<>
          [:div.mb-2 [conversation-tabs tr]]
          (if (> tab-index 0)
            [:div.message-thread.flex-auto.flex.flex-col.min-w-none.max-w-none
             [direct-workspace-conversation-view tr user :workspace (:workspace selected-ws) true]]
            [:<>
             [conversation-participants tr]
             [:div.message-thread.flex-auto.flex.flex-col.min-w-none.max-w-none
              [public-workspace-conversation-view tr :workspace (:workspace selected-ws)]]])])])))
